// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.notes {
  padding: 10px;
}
.notes .note-date {
  grid-column-start: 1;
}
.notes .note-name {
  grid-column-start: 2;
  font-weight: bold;
  color: #4b58a6;
}
.notes .note-text {
  grid-column-start: 3;
}
.button-row {
  display: flex;
  justify-content: flex-end;
}
h2.filter-title {
  width: 100%;
  display: block;
  text-align: center;
  background: #bfc3ce;
}
.grid.calls-form {
  padding: 0;
}
`, "",{"version":3,"sources":["webpack://./src/app/shared-components-module/verification-call/verification-call.component.less"],"names":[],"mappings":"AAAA;EACI,aAAA;AACJ;AAFA;EAGQ,oBAAA;AAER;AALA;EAMQ,oBAAA;EACA,iBAAA;EACA,cAAA;AAER;AAVA;EAWQ,oBAAA;AAER;AAIA;EACI,aAAA;EACA,yBAAA;AAFJ;AAKA;EACI,WAAA;EACA,cAAA;EACA,kBAAA;EACA,mBAAA;AAHJ;AAMA;EACI,UAAA;AAJJ","sourcesContent":[".notes{\n    padding: 10px;\n    .note-date{\n        grid-column-start: 1\n    }\n    .note-name{\n        grid-column-start: 2;\n        font-weight: bold;\n        color: #4b58a6\n    }\n    .note-text{\n        grid-column-start: 3\n    }\n    // .note-number{\n    //     grid-column-start: 3\n    // }\n}\n.button-row{\n    display:flex;\n    justify-content: flex-end;\n}\n\nh2.filter-title{\n    width:100%;\n    display:block;\n    text-align: center;\n    background: #bfc3ce;\n}\n\n.grid.calls-form{\n    padding:0;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
